webpackJsonp([115222812963989],{

/***/ 1407:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreateStockTransferRequestItemsInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"requestItems","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"INPUT_OBJECT","name":"CreateStockTransferRequestItemInput"}}}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-create-stock-transfer-request-items-input-6765640cccfc60458821.js